import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'cmv-pdf-viewer',
	templateUrl: './pdf-viewer.component.html',
	styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
	@Input()
	title: string = 'title';
	@Input()
	pdfUrl: string = '';
	/**
	 * Cuando se proporciona, el visor muestra esta URL dentro de un iframe (webview)
	 * en lugar de renderizar un PDF. Útil para documentos que ahora viven en línea,
	 * como el aviso de privacidad.
	 */
	@Input()
	webUrl: string = '';
	/**
	 * Valor del atributo `sandbox` del iframe en modo webview. Por defecto es
	 * restrictivo (solo lectura) para páginas HTML. Para documentos PDF conviene
	 * `allow-scripts allow-same-origin` para que el visor nativo del navegador
	 * los renderice. Usar `null` para omitir el atributo por completo.
	 */
	@Input()
	webViewSandbox: string | null = 'allow-same-origin';
	@Output()
	closePdfViewer: EventEmitter<void> = new EventEmitter();
	isPdfViewerVisible: boolean = true;
	safeWebUrl: SafeResourceUrl | null = null;

	constructor(private sanitizer: DomSanitizer) {}

	ngOnInit(): void {
		if (this.webUrl) {
			this.safeWebUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
				this.webUrl
			);
		}
	}

	get isWebView(): boolean {
		return !!this.webUrl;
	}

	onClose(): void {
		this.closePdfViewer.emit();
	}
}
